import React, { memo, useEffect, useCallback, useState} from 'react';
import ModulatorControl from './ModulatorControl.js';
import {connect} from 'react-redux';
import '../../Modulators.scss';

const ModulatorControls = ({parameter, sequencerEngine}) => { 
    if (!sequencerEngine || !parameter || !parameter.lfos || !parameter.envelopes) {
        return [];
    }
    let _lfos = [... parameter.lfos];
    _lfos.sort((a,b) => a.number - b.number);
    let _envelopes = [... parameter.envelopes];
    _envelopes.sort((a,b) => a.number - b.number);

    return (
        <div className="modulator-controls">
          {_lfos.map(
              lfo =>
                  <ModulatorControl
                    key={lfo.number}
                    sequencerEngine={sequencerEngine}
                    lfo={lfo}
                    parameter={parameter}/>)}
          {_envelopes.map(
              env =>
                  <ModulatorControl
                    key={env.number}
                    sequencerEngine={sequencerEngine}
                    envelope={env}
                    parameter={parameter}/>)}
        {parameter.keyScaling ?
                  <ModulatorControl
                    sequencerEngine={sequencerEngine}
                    keyScaling={parameter.keyScaling}
                    parameter={parameter}/> : ''}
        </div>
    );
};

const mapStateToProps = (state, props) => {
    if (!props.parameter) {
        return {};
    }
    return {
        lfos: props.parameter.lfos,
        envs: props.parameter.envelopes,
        keyScaling: props.parameter.keyScaling,
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModulatorControls);
